import { NgIf } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from '@angular/core';

@Component({
  templateUrl: './column-sku-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf],
})
export class ColumnSkuTitleComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;
  public initCallback: () => void;

  ngAfterViewInit() {
    this.initCallback();
  }
}
